import { render, staticRenderFns } from "./OpenLogin.vue?vue&type=template&id=53acf8cc&scoped=true&"
import script from "./OpenLogin.vue?vue&type=script&lang=js&"
export * from "./OpenLogin.vue?vue&type=script&lang=js&"
import style0 from "./OpenLogin.vue?vue&type=style&index=0&id=53acf8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acf8cc",
  null
  
)

export default component.exports